"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = exports.formatPercent = exports.formatDate = exports.formatCurrency = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _i18n = require("../constants/i18n");

var formatPercent = function formatPercent(amount) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _i18n.defaultLocale;
  var options = (0, _extends2["default"])({
    currency: _i18n.defaultCurrency,
    minimumFractionDigits: 2
  }, format, {
    style: 'percent'
  });
  return amount && amount.toLocaleString(locale, options);
};

exports.formatPercent = formatPercent;

var formatCurrency = function formatCurrency() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _i18n.defaultLocale;
  var options = (0, _extends2["default"])({
    currency: _i18n.defaultCurrency,
    minimumFractionDigits: 2
  }, format, {
    style: 'currency'
  });
  return amount.toLocaleString(locale, options);
};

exports.formatCurrency = formatCurrency;

var formatDate = function formatDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _i18n.defaultLocale;
  var options = (0, _extends2["default"])({
    year: 'numeric',
    month: 'long',
    day: '2-digit'
  }, format);
  return date && date.toLocaleString(locale, options);
};

exports.formatDate = formatDate;

var formatTime = function formatTime(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _i18n.defaultLocale;
  var options = (0, _extends2["default"])({
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }, format);
  return date && date.toLocaleString(locale, options);
};

exports.formatTime = formatTime;